import { createSlice } from '@reduxjs/toolkit';

import { updateClientDataReportCase } from './cases/updateClientDataReport';
import { updateDebtorDataReportCase } from './cases/updateDebtorDataReport';
import { initialFilters } from './initialState';

const slice = createSlice({
  name: 'dataReportEvaluation',
  initialState: initialFilters,
  reducers: {
    updateClientDataReport: updateClientDataReportCase,
    updateDebtorDataReport: updateDebtorDataReportCase,
  },
});

const { reducer } = slice;

export const { updateClientDataReport, updateDebtorDataReport } = slice.actions;

export default reducer;
